import { coreClient } from './staffToken'

// Busca no backend-core de quem pode ser convidado para a conversa (modal "Direcionar").
// Usa o coreClient do chat: o axios global desloga em 403, e aqui 403 só quer dizer
// "este perfil não pode usar este filtro".

const normalize = error => {
  const normalized = error
  if (error && error.response) normalized.status = error.response.status
  return Promise.reject(normalized)
}

export const fetchInvitableUsers = params => coreClient
  .get('/api/customer-chat/invitable-users', { params })
  .then(response => (response.data && Array.isArray(response.data.data) ? response.data.data : []))
  .catch(normalize)

// GET /api/departments (existente) exige consultant:read/manage; sem ela, o filtro some.
export const fetchDepartments = () => coreClient
  .get('/api/departments')
  .then(response => {
    const body = response.data
    let list = []
    if (Array.isArray(body)) list = body
    else if (body && Array.isArray(body.data)) list = body.data
    return list
      .filter(department => department && department.id && department.name)
      .map(department => ({ id: department.id, name: department.name }))
  })
  .catch(normalize)
